<script setup>
import OOverlay from '@weathernews/mi-web-design/organisms/OOverlay.vue'
import MOverlayBlock from '@weathernews/mi-web-design/molecules/MOverlayBlock.vue'
import ARadarButton from '@weathernews/mi-web-design/atoms/ARadarButton.vue'
import ACloseButton from '@weathernews/mi-web-design/atoms/ACloseButton.vue'

const props = defineProps({
  mapCenter: { type: Array, required: true },
  mapZoom: { type: Number, required: true },
  tmpMarkerPosition: { type: Object, required: true }
})
const route = useRoute()
const config = useRuntimeConfig()
const isOverlayOpen = defineModel('isOverlayOpen', { type: Boolean })
const position = useCookie('mapView')
const markerPosition = useCookie('markerPosition', { default: () => null })

const onClickButton = (weather) => {
  if (weather === 'kosa') {
    isOverlayOpen.value = false
    return
  } else {
    position.value = { lat: props.mapCenter[1], lon: props.mapCenter[0], zoom: props.mapZoom }
    if (Object.keys(props.tmpMarkerPosition).length > 0) {
      markerPosition.value = props.tmpMarkerPosition
    }
    const path = createRadarLink(weather, route.path)
    return navigateTo(`${config.public.hostDomain}${path}`, { external: true })
  }
}
</script>

<template>
  <OOverlay
    :data-showed="isOverlayOpen"
    @click.self="isOverlayOpen = false"
  >
    <MOverlayBlock
      data-position="right"
      data-style="border"
    >
      <template
        v-for="[category, label] in Object.entries(linkConfig)"
        :key="category"
      >
        <ARadarButton>
          <KosaRadarLinkButton
            :category="category"
            :label="label"
            @click="onClickButton(category)"
          />
        </ARadarButton>
      </template>
      <ACloseButton data-type="circle">
        <button @click="isOverlayOpen = false" />
      </ACloseButton>
    </MOverlayBlock>
  </OOverlay>
</template>

<style lang="scss" scoped>
</style>
